/** SMS messaging adapter — STUB (Twilio / MessageBird / vendor-agnostic). Implements MessagingPort. */
export function createSmsMessaging() {
  return {
    async availableChannels() { return ["sms"]; },
    async channelStatus() { return { status: "not_connected" }; },
    async send() { throw new Error("SMS_ADAPTER_NOT_IMPLEMENTED"); },
  };
}
